interface RovoMessageActionError extends Error {
	errorAttributes: {
		conversationId: string;
		messageId: string;
		invocationId: string;
		actionKey: string;
	};
}

export class MessageActionError extends Error implements RovoMessageActionError {
	errorAttributes: RovoMessageActionError['errorAttributes'];
	cause?: Error;

	constructor(params: {
		message: string;
		conversationId: string;
		messageId: string;
		invocationId: string;
		actionKey: string;
		cause?: Error;
	}) {
		super(params.message);
		this.name = this.constructor.name;
		this.errorAttributes = {
			conversationId: params.conversationId,
			messageId: params.messageId,
			invocationId: params.invocationId,
			actionKey: params.actionKey,
		};
		if (params.cause) {
			this.cause = params.cause;
		}
	}
}
